import { render, staticRenderFns } from "./booking-receipts.vue?vue&type=template&id=23a2db4a&"
import script from "./booking-receipts.vue?vue&type=script&lang=js&"
export * from "./booking-receipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports